import { Listbox_Option_default } from "./chunk-4XCY4XHL.js";
import { Listbox_default } from "./chunk-ZBEBQIS7.js";

// src/elements/Listbox/index.ts
var ListboxComponent = Listbox_default;
ListboxComponent.Option = Listbox_Option_default;
ListboxComponent.Option.displayName = "Listbox.Option";
export { ListboxComponent };